module.exports = __webpack_public_path__ + "static/media/meter_2.2d1f9ff5.svg";